<div class="display-flex flex-direction-column">
  <h3 class="t-5@r color-black mb-4">You need more Credits</h3>

  @if (affordablePhotosCount) {
    <div class="t-8@r color-charcoal mb-0 font-weight-500">
      You have enough credits for: {{ affordablePhotosCount | pluralize: 'Photo' }}
    </div>

    <div class="t-8@r color-ash mb-6">Top up with credits to {{ mode }} all.</div>
  } @else {
    <div class="t-8@r color-charcoal mb-0 font-weight-500">
      Your credits balance: {{ memberService.account.token_balance }}
    </div>

    <div class="t-8@r color-ash mb-6">
      Send photos directly to members for just {{ memberService.account.costs.send_message_photo }} credits per photo.
    </div>
  }

  <button
    class="mb-4"
    sbButton
    [size]="'big'"
    [stretchable]="true"
    [variant]="'fill-gold'"
    (click)="confirm('Buy Credits')"
  >
    Buy Credits
  </button>

  @if (affordablePhotosCount > 0) {
    <button sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-blue'" (click)="confirm('Send')">
      <sb-icon [name]="'send'" />
      Send {{ affordablePhotosCount | pluralize: 'Photo' }}
    </button>
  } @else {
    <button sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">Cancel</button>
  }
</div>
